module.exports = __webpack_public_path__ + "static/media/Group 1583@3x.5f87ad14.png";